import content from "./content/what-is-cryptocurrency-trading.json";

export const whatIsCryptocurrencyTradingMock = {
  name: "what-is-cryptocurrency-trading",
  layoutType: 1,
  areasList: [
    {
      id: "what-is-cryptocurrency-trading-main",
      componentName: "Comp:WhatIsCryptocurrencyTradingPage",
      content: JSON.stringify(content),
    },
  ],
};
